import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import About from "./components/About";
import ContentCreators from "./components/ContentCreators";
import Home from "./components/Home";
import Nav from "./components/Nav";
import Pricing from "./components/Pricing";
import HowItWorks from "./components/HowItWorks";
import CustomerStories from "./components/CustomerStories";
import Details from "./components/Details";
import Reviews from "./components/Reviews";
import PrivacyPolicy from "./components/PrivacyPolicy";
import FAQs from "./components/FAQs";
import FAQsPage from "./components/FAQsPage";
import TermsAndConditions from "./components/TermsAndConditions";
import VideoCraftShow from "./components/VideoCraftShow";
import Contact from "./components/Contact";
import LatestEpisodes from "./components/LatestEpisodes";
import Podcast from "./components/Podcast";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/content-creators" element={<ContentCreators />} />
          <Route exact path="/how-it-works" element={<HowItWorks />} />
          <Route
            exact
            path="/category/case-studies"
            element={<CustomerStories />}
          />
          <Route exact path="/about" element={<About />} />
          <Route exact path="/pricing" element={<Pricing />} />
          <Route exact path="/reviews" element={<Reviews />} />
          {/* <Route exact path="/privacyPolicy" element={<PrivacyPolicy />} /> */}
          <Route exact path="/FAQs" element={<FAQsPage />} />
          <Route exact path="/contact-us" element={<Contact />} />
          {/* <Route exact path="/video-craft-show" element={<VideoCraftShow />} /> */}
          <Route exact path="/category/podcast" element={<Podcast />} />
          {/* <Route
            exact
            path="/video-craft-show/episode"
            element={<LatestEpisodes />}
          /> */}
          {/* <Route
            exact
            path="/terms&conditions"
            element={<TermsAndConditions />}
          /> */}
          <Route
            exact
            path="/category/case-studies/details"
            element={<Details />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
